var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVersionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 221,
    viewBox: "0 0 211 221",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_376_4853)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_376_4853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.111 55.5302L97.7252 104.13L115.043 98.9231L122.35 123.223L70.3976 138.845C60.7865 141.735 55.2481 151.262 57.9517 160.253L65.2588 184.553L47.9415 189.76L62.5557 238.361L114.508 222.738L99.8935 174.138L82.5761 179.346L75.269 155.045L127.221 139.423L134.528 163.723L117.211 168.931L131.825 217.531L183.777 201.909L169.163 153.309L151.845 158.516L144.538 134.216L196.49 118.594L203.798 142.894L186.48 148.101L201.094 196.702L253.046 181.08L238.432 132.479L221.115 137.687L213.808 113.386C211.104 104.395 201.23 99.5037 191.619 102.394L139.667 118.016L132.36 93.7157L149.677 88.5083L135.063 39.9081L83.111 55.5302Z",
    fill: "#58595B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_376_4853"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 217,
    height: 203,
    fill: "white",
    transform: "translate(0.311523 62.7632) rotate(-16.7362)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_376_4853"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 217,
    height: 203,
    fill: "white",
    transform: "translate(0.311523 62.7632) rotate(-16.7362)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVersionIcon);
export default __webpack_public_path__ + "static/media/version-icon.347c1bc26e48bffa5cf1cea1547fcf2d.svg";
export { ForwardRef as ReactComponent };